// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"v1-z","colorTextValue":"w1-z","swatches":"x1-z","collapseLink":"y1-z","isCollapsed":"z1-z","dropdown":"A1-z","disabled":"B1-z"};